import { SEARCH_LOGFILES_API, DOWNLOAD_LOG_FILES_API } from '~/constants/APIs'
import { ILogFileSearchReponse, ILogFileSearchRequest } from '~/models'
import axiosClient from './axiosClient'

export const logFileApis = {
  searchLogFiles: (params: ILogFileSearchRequest | null) =>
    axiosClient.get(SEARCH_LOGFILES_API, {
      params
    }) as unknown as ILogFileSearchReponse,

  downLoadLogFiles: (category: string, windowsUser: string, fileNames: string[]) =>
    axiosClient.get(DOWNLOAD_LOG_FILES_API + category + '/' + windowsUser, {
      params: { fileNames },
      responseType: 'blob'
    }),
  downLoadALogFile: (category: string, windowsUser: string, fileName: string) =>
    axiosClient.get(
      DOWNLOAD_LOG_FILES_API + category + '/' + windowsUser + '/' + fileName,
      {
        responseType: 'blob'
      }
    )
}
